import * as constants from './constants';

export const loadTasks = params => ({
  type: constants.LOAD_TASKS,
  params
});
